import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type AppointmentPatientBookModalLoaderRenderer = (renderProps: { patient: PatientSimple }) => JSX.Element;

type AppointmentPatientBookModalLoaderProps = {
   readonly children: AppointmentPatientBookModalLoaderRenderer;
   readonly patientId: number;
};

export const AppointmentPatientBookModalLoader = (props: AppointmentPatientBookModalLoaderProps): JSX.Element => {
   const { data: patient, loading: patientLoading, error: patientError } = useCqrsGet<PatientSimple>(() => {
      const query = new PatientSimpleQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   if (patientLoading) {
      return <LoaderSpinner />;
   }

   if (patientError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      patient: patient,
   });
};
